import { useEffect } from 'react'

// A wrapper that stops React event bubbling (portal events reach the row that
// rendered the sheet) also stops the pointerdown Vaul uses to dismiss, so a tap
// on the dimmed area never closes the sheet. Close on the click instead: closing
// on pointerdown unmounts the overlay first, and the click then lands on the row.
export function useCloseOnOverlayTap(open: boolean, onOpenChange: (open: boolean) => void) {
  useEffect(() => {
    if (!open) return
    const onClick = (event: globalThis.MouseEvent) => {
      const target = event.target
      if (!(target instanceof Element)) return
      if (!target.closest('[data-vaul-overlay]')) return
      if (target.closest('[data-vaul-drawer]')) return
      event.preventDefault()
      event.stopPropagation()
      onOpenChange(false)
    }
    document.addEventListener('click', onClick, true)
    return () => document.removeEventListener('click', onClick, true)
  }, [open, onOpenChange])
}
